export default __webpack_public_path__ + "static/media/matemask.b88ad81d.svg";